import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { bdt } from "@/lib/shop";
import { scrollToId } from "@/lib/scroll";

export default function StickyCTA({ hidden, totals }) {
    const empty = totals.qty === 0;
    return (
        <AnimatePresence>
            {!hidden && (
                <motion.div
                    initial={{ y: 90 }}
                    animate={{ y: 0 }}
                    exit={{ y: 90 }}
                    transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-[#1A1715]/95 backdrop-blur-md border-t border-[#3A342C] px-4 py-3 flex items-center justify-between gap-3"
                    data-testid="sticky-mobile-cta"
                >
                    <div>
                        <p className="text-[#F4EFE6] font-extrabold text-lg leading-none" data-testid="sticky-cta-price">
                            {empty ? "৳৯০০ / পাঞ্জাবি" : bdt(totals.total)}
                        </p>
                        <p className="text-[11px] text-[#B9B0A3] mt-1" data-testid="sticky-cta-sub">
                            {empty ? "আগে পণ্য বাছাই করুন" : totals.offer || "ডেলিভারিসহ মোট"}
                        </p>
                    </div>
                    <button
                        onClick={() => scrollToId("order-form")}
                        data-testid="sticky-mobile-cta-button"
                                            className="bg-[#A84320] text-[#FBF9F5] font-semibold px-5 py-2.5 rounded-full text-[13px] hover:bg-[#8C3417] active:scale-[0.97] transition-all duration-200 shrink-0"
                    >
                        এখনই অর্ডার করুন
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
